import React from "react";
import { copyText } from "../lib/clipboard";
import { Button, IconButton } from "../design";

export function SecretReveal({ value }: { value: string }) {
  const [copied, setCopied] = React.useState(false);
  const [revealed, setRevealed] = React.useState(true);
  const tRef = React.useRef<number | null>(null);

  const copy = async () => {
    await copyText(value);
    setCopied(true);
    if (tRef.current) window.clearTimeout(tRef.current);
    tRef.current = window.setTimeout(() => setCopied(false), 1600);
  };

  const masked = revealed ? value : "•".repeat(Math.min(28, value.length));

  return (
    <div className={`per-cmd per-secret${copied ? " copied" : ""}`}>
      <code className="per-cmd-text per-secret-value" title="Click to select">
        {masked}
      </code>
      <IconButton
        size="sm"
        icon={revealed ? "eye-off" : "eye"}
        label={revealed ? "Hide secret" : "Show secret"}
        onClick={() => setRevealed((v) => !v)}
      />
      <Button
        size="sm"
        variant={copied ? "ghost" : "secondary"}
        icon={copied ? "check" : "copy"}
        onClick={copy}
        aria-label="Copy secret"
      >
        {copied ? "Copied" : "Copy"}
      </Button>
    </div>
  );
}
